'use strict';
const angular = require('angular');

export class signInSheetFormComponent {
  /*@ngInject*/
  constructor(AttendanceService, dialogs, User, Auth) {
    this.Auth = Auth;
    this.AttendanceService = AttendanceService;
    this.dialogs = dialogs;
    this.User = User;

    this.types = [{
      type: 'member',
      description: 'Member'
    },{
      type: 'guest',
      description: 'Guest'
    },{
      type: 'sub',
      description: 'Sub'
    }];

    let signInTime = new Date();

    this.attendance = {
      type: 'member',
      signInTime: signInTime,
      meetingDate: new Date(signInTime.getTime() - (signInTime.getTimezoneOffset() * 60000 )).toISOString().split("T")[0],
      meta: {
        creationUser: Auth.getCurrentUserSync()._id
      }
    };
  }

  $onInit() {

    this.alreadySignedInToday = [];
    if (this.resolve && this.resolve.config && this.resolve.config.alreadySignedInToday) {
      this.alreadySignedInToday = this.resolve.config.alreadySignedInToday;
    }

    if (this.resolve && this.resolve.config && this.resolve.config.attendance) {
      this.isEdit = true;
      let attendance = angular.copy(this.resolve.config.attendance);

      if (attendance.member && attendance.member._id) {
        attendance.member = attendance.member._id;
      }
      
      this.attendance = attendance;
    } else {
      this.isEdit = false;
    }

    this.User.query(data => {
      this.users = data.filter(user => user.active && user.role.includes("member")).map(user => {
        user.fullName = user.firstName + ' ' + user.lastName + ' - ' + user.companyName;

        user.state = (this.alreadySignedInToday.includes(user._id)) ? "Already Signed-In" : "Not Yet Signed-In";

        return user;
      });
    });
  }

  submit() {

    if (this.attendance.type == 'member') {
      if (!this.attendance.member) {
        this.dialogs.notify("SignIn Issue", "You have to select a member");
        return;
      }
      
      if (this.attendance.member && this.alreadySignedInToday.includes(this.attendance.member)) {
        this.dialogs.notify("SignIn Issue", "You have already signed in this member today");
        return;
      }
    } else if (this.attendance.type == 'guest') {
      if (!this.attendance.member) {
        this.dialogs.notify("SignIn Issue", "Please specify 'Guest of'");
        return;
      }

      if (!this.attendance.attendedBy) {
        this.dialogs.notify("SignIn Issue", "Please specify the name of the guest");
        return;
      }
    } else {
      if (!this.attendance.member) {
        this.dialogs.notify("SignIn Issue", "Please specify 'Sub for'");
        return;
      }

      if (!this.attendance.subName) {
        this.dialogs.notify("SignIn Issue", "Please specify the name of the sub");
        return;
      }
    }

    if (this.attendance.type === 'member') {
      let user = this.users.find(user => user._id == this.attendance.member);
      if (user) {
        this.attendance.attendedBy = user.firstName + " " + user.lastName;
      }
    }

    if (this.isEdit) {
      this.AttendanceService.update({id: this.attendance._id}, this.attendance, () => {
        this.dismiss();
      });
    } else {
      this.AttendanceService.save(this.attendance, () => {
        this.dismiss();
      });
    }
  }
}

export default angular.module('conduuApp.signInSheetForm', [])
  .component('signInSheetForm', {
    template: require('./sign-in-sheet-form.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      dismiss: '&'
    },
    controller: signInSheetFormComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sign-in-sheet-form/sign-in-sheet-form.component.js